import classNames from 'classnames/bind';
import { Dispatch, SetStateAction, useRef } from 'react';

import { RecommendModal } from 'everywhere/common';
import useAniScroll from 'hooks/useAniScroll';
import useThemes, { ITheme } from 'hooks/useThemes';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  selectedTheme?: number;
  setRecommendModal: Dispatch<SetStateAction<RecommendModal>>;
  themeFilter: (theme: number) => void;
}

export default ({
  selectedTheme = 0,
  setRecommendModal,
  themeFilter,
}: IProps) => {
  const themes: ITheme[] = useThemes();
  const ref = useRef<HTMLDivElement>(null);

  const { aniScroll } = useAniScroll({
    ref,
    duration: 400,
    easeFunc: 'easeInOut',
    targetPer: 0.25,
  });

  return (
    <div className={cx('ThemeFilter')}>
      <div className={cx('inner')} ref={ref}>
        {themes.map(
          (theme: { theme_id: number; theme_name: string }, idx: number) => {
            return (
              <button
                key={theme.theme_id}
                id={`buttonText_${idx}`}
                className={cx('theme')}
                type="button"
                aria-selected={theme.theme_id === selectedTheme}
                data-event-nlog="click"
                data-event-area-code={`rcm.theme${theme.theme_id || ''}`}
                onClick={() => {
                  aniScroll(`buttonText_${idx}`);
                  themeFilter(theme.theme_id);
                }}
              >
                {theme.theme_name}
              </button>
            );
          },
        )}
      </div>
      <button
        type="button"
        aria-label="더보기"
        className={cx('more')}
        data-event-nlog="click"
        data-event-area-code="rcm.themeopen"
        onClick={() => {
          setRecommendModal(RecommendModal.Theme);
        }}
      />
    </div>
  );
};
